import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import { IPageStatus } from '../../../type';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
interface IProps {
    data?: any;
}

const imgs: Record<string, { pc: string; h5: string }> = {
    us: {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269898687/Shop%20to%20the%20collection%20pagejpg.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711269867963/Shop%20to%20the%20collection%20pagejpg.jpg',
    },
    au: {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611734816/PC_%E5%A4%9A%E8%A7%84%E6%A0%BC.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611717222/MO_%E5%A4%9A%E8%A7%84%E6%A0%BC.jpg',
    },
    uk: {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711764793605/PC-UKjpg.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711764838564/MO-UKjpg.jpg',
    },
    eu: {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711764869245/PC-EUjpg.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711764893206/MO-EUjpg.jpg',
    },
};

const BannerViewB: FC<IProps> = ({ data = {} }) => {
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const { pageStatus } = useMembersStore();
    // 真是罪恶,为啥那帮家伙不统一一下页面链接,为啥ca又搞一个特殊链接,执行成本老是涨涨涨
    const linkObj: any = {
        [IPageStatus.ACTIVITY]: `https://${locale}.ecoflow.com/collections/members-day`,
        [IPageStatus.RETURN]: `https://${locale}.ecoflow.com/pages/refurbished`,
    };
    const linkA = linkObj[pageStatus] || linkObj[IPageStatus.ACTIVITY];
    // naList
    const naList = ['us', 'ca'];
    return (
        <div className={`${styled.content} members-day-inter`}>
            <div className="box-inter">
                <EditorImg pc={imgs[locale]?.pc || imgs.us.pc} h5={imgs[locale]?.h5 || imgs.us.h5} />
                <div className="box-msg">
                    <div className="box-title">{t('BannerViewB.title')}</div>
                    <EditorLink
                        className="box-desc"
                        href={naList.includes(locale) ? linkObj[IPageStatus.ACTIVITY] : linkA}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: t('product_title3'),
                            position: 'EcoCredits day',
                        }}
                    >
                        {t('BannerViewB.desc')}
                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="box-icon">
                            <path id="Vector" d="M1 13L7 7L1 1" stroke="#FFBD3C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </EditorLink>
                </div>
            </div>
        </div>
    );
};

export default BannerViewB;
